import tinymce from "tinymce/tinymce";
import "tinymce/icons/default";
import "tinymce/themes/silver";
import "tinymce/models/dom/model";

// CSS
import "tinymce/skins/ui/oxide/skin.css";

export default defineNuxtPlugin(() => {
    return {
        provide: { tinymce }
    };
});
